// frontend/src/features/citysense/housing-stock-modeller/utils/calculator.ts

import { HousingPolygon, HousingSummary } from "../types";
import { RETROFIT_DATA, extractAgeClass } from "../constants/housingConfig";

export function computeSummary(polygons: HousingPolygon[]): HousingSummary {
  let totalDwellings = 0;
  let totalHouses = 0;
  let totalFlats = 0;
  let totalRetrofitCost = 0;
  let totalGHGSavings = 0;

  const archetypeMap = new Map<
    string,
    { count: number; dwellings: number; cost: number; ghg: number }
  >();

  polygons.forEach((poly) => {
    totalDwellings += poly.dwellings;
    totalHouses += poly.houses;
    totalFlats += poly.flats;

    const ageClass = extractAgeClass(poly.archetype);
    const retrofitInfo = RETROFIT_DATA[ageClass];

    const cost = retrofitInfo.cost * poly.dwellings;
    const ghg = retrofitInfo.twentyYear * poly.dwellings;

    totalRetrofitCost += cost;
    totalGHGSavings += ghg;

    if (!archetypeMap.has(poly.archetype)) {
      archetypeMap.set(poly.archetype, {
        count: 0,
        dwellings: 0,
        cost: 0,
        ghg: 0,
      });
    }

    const entry = archetypeMap.get(poly.archetype)!;
    entry.count++;
    entry.dwellings += poly.dwellings;
    entry.cost += cost;
    entry.ghg += ghg;
  });

  const archetypeBreakdown = Array.from(archetypeMap.entries()).map(
    ([archetype, data]) => ({
      archetype,
      count: data.count,
      dwellings: data.dwellings,
      cost: data.cost,
      ghg: data.ghg,
    }),
  );

  return {
    totalDwellings,
    totalHouses,
    totalFlats,
    totalRetrofitCost,
    totalGHGSavings,
    archetypeBreakdown,
  };
}
